import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type toolTipProps = {
    content: string
    icon: any;
    positionOfToolTop: 'top' | 'bottom' | 'left' | 'right';
    customClassName?: string

}

const CommonTooltipComponent = (props: toolTipProps) => {
    const { content, icon, positionOfToolTop, customClassName, } = props
    return (

        <OverlayTrigger key={positionOfToolTop} placement={positionOfToolTop}
            overlay={
                <Tooltip id={`tooltip-bottom`} bsPrefix={`${customClassName} text-dark`}>
                    {content}
                </Tooltip>
            }
        >
            {icon}
        </OverlayTrigger>

    )
}

export default CommonTooltipComponent